import Env from '../base/env';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import easesCustom from '../fx/CustomEases';

function detectOffsetStart(el) {
  let offsetStart;
  if (typeof el.getAttribute('data-start') != 'undefined') {
    offsetStart = el.getAttribute('data-start');
  }
  if (
    Env.mobileCSS &&
    typeof el.getAttribute('data-start-mobile') != 'undefined'
  ) {
    offsetStart = el.getAttribute('data-start-mobile');
  }
  return offsetStart;
}

export function calculateMask(el, direction, type = 'width') {
  const dimensions = el.getBoundingClientRect();
  let value;
  if (direction == 'from') {
    if (type == 'width') {
      value = `rect(0px,0px,${dimensions.height}px,0)`;
    } else {
      value = `rect(0px,${dimensions.width}px,0px,0)`;
    }
  } else if (direction == 'to') {
    value = `rect(0px,${dimensions.width}px,${dimensions.height}px,0)`;
  }
  return value;
}

export function RevealFadeX(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 50%';
  offsetStart = detectOffsetStart(el);
  let value = 50;
  if (typeof el.getAttribute('data-direction') != 'undefined') {
    value *= el.getAttribute('data-direction');
  }
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      autoAlpha: 0,
      x: value,
    },
    {
      autoAlpha: 1,
      x: 0,
      duration: 1.5,
      ease: 'quint.out',
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add('is-animated');
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealFadeY(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 50%';
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;

  gsap.fromTo(
    el,
    {
      autoAlpha: 0,
      y: 50,
    },
    {
      autoAlpha: 1,
      y: 0,
      duration: 1.5,
      ease: 'quint.out',
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add('is-animated');
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealFade(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 60%';
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      duration: 1.5,
      ease: 'cubic.inOut',
      delay: delayFx * 1,
      onStart: () => {
        setTimeout(() => {
          el.classList.add('is-animated');
        }, 400);
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealFadeOut(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 60%';
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      autoAlpha: 1,
    },
    {
      autoAlpha: 0,
      duration: 0.8,
      ease: easesCustom.cubic,
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add('is-animated');
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealMask(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 60%';
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      y: '150%',
    },
    {
      y: 0,
      duration: 0.8,
      ease: easesCustom.quart,
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add('is-animated');
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealScale(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 60%';
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      scale: 1.1,
    },
    {
      scale: 1,
      duration: 1.5,
      ease: 'quint.out',
      delay: delayFx * 1,
      onStart: () => {
        setTimeout(() => {
          el.classList.add('is-animated');
        }, 400);
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealScaleOut(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 60%';
  offsetStart = detectOffsetStart(el);
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      scale: 0.9,
    },
    {
      scale: 1,
      duration: 1.5,
      ease: 'quint.out',
      delay: delayFx * 1,
      onStart: () => {
        setTimeout(() => {
          el.classList.add('is-animated');
        }, 400);
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function RevealScaleX(el) {
  let offsetStart = Env.mobileCSS ? 'top 90%' : 'top 50%';
  offsetStart = detectOffsetStart(el);
  let value = 50;
  if (typeof el.getAttribute('data-direction') != 'undefined') {
    value *= el.getAttribute('data-direction');
  }
  let delayFx =
    typeof el.getAttribute('data-delay') != undefined
      ? el.getAttribute('data-delay')
      : 0;
  gsap.fromTo(
    el,
    {
      transformOrigin: el.getAttribute('data-origin'),
      scaleX: 0,
    },
    {
      scaleX: 1,
      duration: 1,
      ease: 'quint.out',
      delay: delayFx * 1,
      onStart: () => {
        el.classList.add('is-animated');
      },
      scrollTrigger: {
        trigger: el,
        start: offsetStart,
      },
    }
  );
}

export function prepareToFx() {
  gsap.set(document.querySelectorAll('.fxVisualHide'), { autoAlpha: 0 });
}

export function InteractiveModuleRevealText(DOM, FX, cb) {
  gsap.killTweensOf(DOM.bar);
  gsap.killTweensOf(FX.title.chars);
  gsap.killTweensOf(FX.desc.lines);
  gsap.fromTo(
    DOM.bar,
    {
      transformOrigin: 'left top',
      scaleY: 0,
    },
    {
      scaleY: 1,
      duration: 0.7,
      ease: 'quint.out',
    }
  ),
    gsap.fromTo(
      FX.title.chars,
      {
        autoAlpha: 0,
        y: -5,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.05,
        ease: 'quint.out',
        duration: 0.6,
      }
    ),
    gsap.fromTo(
      FX.desc.lines,
      {
        autoAlpha: 0,
        y: -15,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.05,
        ease: 'quint.out',
        duration: 0.8,
        delay: 0.2,
        onComplete: () => {
          if (typeof cb != 'undefined' && typeof cb == 'function') {
            cb();
          }
        },
      }
    );
}
